import { useState } from "react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, Calculator, MessageSquare, History } from "lucide-react";
import { MarketAnalysis } from "@/components/salary/MarketAnalysis";
import { OfferEvaluator } from "@/components/salary/OfferEvaluator";
import { NegotiationStrategy } from "@/components/salary/NegotiationStrategy";
import { HistoryPanel } from "@/components/salary/HistoryPanel";
import { SubscriptionGate } from "@/components/SubscriptionGate";

export default function SalaryNegotiation() {
  const [activeTab, setActiveTab] = useState("market");

  return (
    <DashboardLayout>
      <SubscriptionGate
        requiredPlan="pro"
        feature="Salary Negotiation"
        description="Understand your market value, evaluate offers, and negotiate with confidence using data-driven insights."
      >
        <div className="p-6 space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground">Salary Negotiation</h1>
            <p className="text-muted-foreground">
              Know your worth. Negotiate with confidence. Get paid fairly.
            </p>
          </div>

          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-4">
              <TabsTrigger value="market" className="gap-2">
                <BarChart3 className="h-4 w-4" />
                Market Analysis
              </TabsTrigger>
              <TabsTrigger value="evaluator" className="gap-2">
                <Calculator className="h-4 w-4" />
                Offer Evaluator
              </TabsTrigger>
              <TabsTrigger value="strategy" className="gap-2">
                <MessageSquare className="h-4 w-4" />
                Negotiation Strategy
              </TabsTrigger>
              <TabsTrigger value="history" className="gap-2">
                <History className="h-4 w-4" />
                History
              </TabsTrigger>
            </TabsList>

            <TabsContent value="market">
              <MarketAnalysis />
            </TabsContent>

            <TabsContent value="evaluator">
              <OfferEvaluator />
            </TabsContent>

            <TabsContent value="strategy">
              <NegotiationStrategy />
            </TabsContent>

            <TabsContent value="history">
              <HistoryPanel />
            </TabsContent>
          </Tabs>
        </div>
      </SubscriptionGate>
    </DashboardLayout>
  );
}
